export default "__VITE_ASSET__BKyGFcI9__"